import React from "react";

export default function ServiceList({ data, page, setPage }) {
  return (
    <div className="w-full overflow-y-auto h-[500px] max-w-3xl mx-auto p-4 font-sans">
      {/* Header */}
      <div className="flex items-center justify-between mb-4 px-2">
        <h2 className="text-lg font-semibold text-slate-900">
          Available Services
        </h2>
          <span className="bg-slate-100 text-slate-600 text-xs font-medium px-2 py-1 rounded-full">
                      {data?.services?.data?.length} total
                    </span>

        {/* <div className="flex items-center justify-center gap-2 mt-6 pt-4 border-t border-slate-100">
          <button
            type="button"
            disabled={page === 1}
            onClick={() => setPage(page - 1)}
            className="inline-flex items-center justify-center text-xs font-medium text-slate-600 bg-white hover:bg-slate-50 hover:text-slate-900 border border-slate-200 px-3 py-1.5 rounded-xl shadow-sm transition-all focus:outline-none focus:ring-2 focus:ring-indigo-500/20 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <svg
              className="w-3.5 h-3.5 mr-1"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 19l-7-7 7-7"
              />
            </svg>
            Prev
          </button>

          <span className="text-xs font-semibold text-indigo-700 bg-indigo-50 border border-indigo-100/80 px-3.5 py-1.5 rounded-xl font-mono">
            Page {data?.services?.current_page || 1}
          </span>

          <button
            type="button"
            disabled={data?.services?.last_page === page}
            onClick={() => setPage(page + 1)}
            className="inline-flex items-center justify-center text-xs font-medium text-slate-600 bg-white hover:bg-slate-50 hover:text-slate-900 border border-slate-200 px-3 py-1.5 rounded-xl shadow-sm transition-all focus:outline-none focus:ring-2 focus:ring-indigo-500/20"
          >
            Next
            <svg
              className="w-3.5 h-3.5 ml-1"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5l7 7-7 7"
              />
            </svg>
          </button>
        </div> */}
      </div>

      {/* List Container */}
      <div className="bg-white border border-slate-200 rounded-xl shadow-sm overflow-hidden divide-y divide-slate-100">
        {data?.services?.data?.map((service) => (
          <div
            key={service.id}
            className="flex flex-col sm:flex-row sm:items-center justify-between p-4 hover:bg-slate-50 transition-colors gap-3 sm:gap-0"
          >
            {/* Left Side: ID and Name */}
            <div className="flex items-center gap-3">
              <span className="flex items-center justify-center w-8 h-8 rounded-lg bg-indigo-50 text-indigo-600 text-xs font-bold border border-indigo-100 shrink-0">
                {service.id}
              </span>
              <span className="text-sm font-medium text-slate-800">
                {service.service_name}
              </span>
            </div>

            {/* Right Side: Endpoint */}
            <div className="flex items-center sm:justify-end">
              <span className="font-mono text-xs text-slate-500 bg-slate-100/80 px-2.5 py-1.5 rounded border border-slate-200/60 truncate max-w-[250px] sm:max-w-none">
                {service.end_point}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
